<template>
  <nav
    id="mainNavigation"
    class="navbar navbar-default main-navigation"
    role="navigation"
  >
    <div class="container">
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-toggle collapsed"
          data-toggle="collapse"
          data-target="#main-nav-collapse"
        >
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>

        <!-- navbar logo -->
        <div class="navbar-brand">
          <span class="sr-only">Avada Pro Agency</span>
          <a href="index.html">
            <img
              src="assets/img/main_logo.png"
              class="img-responsive center-block"
              alt="logo"
            />
          </a>
        </div>
        <!-- navbar logo -->
      </div>
      <!-- /.navbar-header -->

      <!-- nav links -->
      <div class="collapse navbar-collapse" id="main-nav-collapse">
        <ul class="nav navbar-nav navbar-right text-uppercase">
          <li>
            <router-link to="/">home</router-link>
          </li>

          <li>
            <router-link to="/about">About</router-link>
          </li>

          <li>
            <router-link to="/service">Services</router-link>
          </li>

          <li>
            <router-link to="/contact">contact</router-link>
          </li>

          <li>
            <a href="https://login.crm.digiprod.ca" target="_blank"
              >Client Area</a
            >
          </li>
        </ul>
      </div>
      <!-- nav links -->
    </div>
    <!-- /.container -->
  </nav>
</template>

<script>
export default {
  name: "NavbarView",
};
</script>

<style scoped>
.navbar-brand img {
  max-height: 50px;
  width: auto;
}

@media (max-width: 768px) {
  .navbar-brand img {
    max-height: 40px;
  }
}
</style>
